module.exports = __webpack_public_path__ + "img/not-data.95442b5c.png";